export class ThingDataItem {
    type: ThingEventType;
    name: string;
    value: any;
}

export enum ThingEventType {
    PROPERTY = 'PROPERTY',
    FIELD = 'FIELD'
}